export default "__VITE_ASSET__BEctEufU__"